module.exports = __webpack_public_path__ + "static/media/item4.65bc33d7.jpg";